import { AxiosRequestConfig } from "axios";
import ApiService from "../utils/api-services";

//!  the Units here are Departments
//!  the Units here are Departments
//!  the Units here are Departments
class DepartmentsService extends ApiService {
  constructor(config?: AxiosRequestConfig) {
    super({
      baseURL: `${process.env.REACT_APP_BASE_LOCALY_URL}/api`,
      ...config,
    });
  }

  public GetDepartmentById = async (id: any): Promise<any> => {
    return await this.get(`/services/app/Unit/Get?Id=${id}`);
  };

  public getDepartmentsWithPagination = async (
    selectedValue: number,
    keyword: any,
    SkipCount: any,
    sector_id: number
  ): Promise<any> => {
    return await this.get(
      `/services/app/Unit/GetAll?MaxResultCount=${selectedValue}&SkipCount=${SkipCount}&Keyword=${keyword}&DepartmentId=${sector_id}`
    );
  };

  public getDepartmentsWithoutPagination = async (
    sector_id?: number
  ): Promise<any> => {
    const query = sector_id
      ? `?MaxResultCount=1000&SkipCount=0&DepartmentId=${sector_id}`
      : "?MaxResultCount=1000&SkipCount=0";
    return await this.get(`/services/app/Unit/GetAll${query}`);
  };

  public AddDepartment = async (body: any): Promise<any> => {
    return await this.post("/services/app/Unit/Create", body);
  };

  public EditDepartment = async (body: any): Promise<any> => {
    return await this.put("/services/app/Unit/Update", body);
  };

  public DeleteDepartment = async (id: any): Promise<any> => {
    return await this.delete(`/services/app/Unit/Delete?Id=${id}`);
  };

  public ReorderDepartments = async (body: any): Promise<any> => {
    return await this.post("/services/app/Unit/Reorder", body);
  };
}

export const Departments = new DepartmentsService();
